import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import PaginationContext from './PaginationContext';


class ScrollContainer extends PureComponent {

  componentDidUpdate() {
    const { setChildrenToScroll } = this.context;
    setChildrenToScroll();
  }

  render() {
    const { scrollContainerReference, paginationOnScroll } = this.context;
    const { render: View } = this.props;

    return <View reference={ scrollContainerReference } onScroll={ paginationOnScroll }/>;
  }
}


ScrollContainer.propTypes = {
  render: PropTypes.func.isRequired
};
ScrollContainer.contextType = PaginationContext;


export default ScrollContainer;
